import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { HtmlEditorComponent } from './html-editor.component';
import { NgDatepickerModule } from 'ng2-datepicker';
import { TagInputModule } from 'ngx-chips';

TagInputModule.withDefaults({
  tagInput: {
    modelAsStrings: true,
    placeholder: '+ Tag'
  }
});

@NgModule({
  imports: [
    CommonModule,
    CKEditorModule,
    FormsModule,
    NgDatepickerModule,
    TagInputModule
  ],
  declarations: [
    HtmlEditorComponent
  ],
  exports: [
    HtmlEditorComponent
  ]
})

export class HtmlEditorModule {
}
